import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=ce61a22c&scoped=true&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=ce61a22c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce61a22c",
  null
  
)

export default component.exports